import { connect } from 'react-redux';
import { onSubmit } from './events/onSubmit';
import { onSkip } from './events/onSkip';
import { getMessages, root } from '../../../../../../store/constants';
import { IApplicationState } from '../../../../../../types/types';
import { Poll } from '../../../../base/components/Poll/components/Poll/Poll';
import { IPollEvents, IPollFields } from '../../../../base/components/Poll/components/Poll/types';
import { EPollQuestionVariant } from '../../../../base/components/Poll/components/PollQuestion/types';
import { onRate } from './events/onRate';
import { onShow } from './events/onShow';
import { getAuthUserPlatformType } from '../../../../../../store/model/authUser/selectors/getAuthUserPlatformType';
import { POLL_TITLE } from '../../../../base/components/Poll/components/Poll/constants';
import { getUserRateKanbanPoll } from '../../../../../../store/model/authUser/selectors/getUserRateKanbanPoll';
import { RATE_KANBAN_POLL_MAX_START_FOR_REVIEW } from './constants';
import { CLASS_POLL } from '../../../../base/components/Poll/components/constants';

const mapStateToProps = (
    state: IApplicationState,
): IPollFields => {
    let isShow = false;
    const isEnabled = root.App.controller && root.App.controller.getRateKanbanPollEnabled();;
    const platformType = getAuthUserPlatformType(state);
    if (!isEnabled) return { isShow, platformType };

    const { isSkipped, lastTimeShowed, isShowed, isTriggered } = getUserRateKanbanPoll(state);
    if (isShowed || !isTriggered) return { isShow, platformType };

    const isTrialExtendOpen = !!document.querySelector('.dialog-blocker__trial-dialog');
    let isAnotherPoll = false;
    const anotherPoll = document.querySelector(`.${CLASS_POLL}`) as HTMLElement;
    if (anotherPoll) {
        isAnotherPoll = !anotherPoll.parentElement.className.includes('poll-placeholder--rate-kanban');
    }
    isShow = !isAnotherPoll && !isTrialExtendOpen;

    if (!isShow) return { isShow, platformType };

    isShow = !lastTimeShowed;

    if (lastTimeShowed && isSkipped) {
        const timeSinceLastShowed = Date.now() - lastTimeShowed;
        const oneDay = 1000 * 60 * 60 * 24;
        const waitTime = oneDay * 2;
        isShow = timeSinceLastShowed > waitTime;
    }

    if (!isShow) return { isShow, platformType };

    return {
        isShow,
        platformType,
        title: POLL_TITLE + getMessages().getText('rate-kanban-poll.title'),
        questionsList: [{ question: '' }],
        reviewTitle: getMessages().getText('poll.rate_kanban_poll.review.title'),
        variant: EPollQuestionVariant.STAR,
        maxStarsForReview: RATE_KANBAN_POLL_MAX_START_FOR_REVIEW,
    };
}

const mapDispatchToProps = (
    dispatch: any,
): IPollEvents => {
    return {
        onRate: () => dispatch(onRate()),
        onShow: () => dispatch(onShow()),
        onSkip: () => dispatch(onSkip()),
        onSubmit: (results) => dispatch(onSubmit(results))
    };
}

export const RateKanbanPollHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Poll);

RateKanbanPollHOC.displayName = 'FeaturePollHOC';
